import { get as getIDB, set as setIDB } from 'idb-keyval';
import cloneDeep from 'lodash/cloneDeep';
import { zlbApiExpenseAddressFileGet, zlbApiExpenseAddressLevelGet } from 'src/api/zlbExpense';
import { getFromFileUrl, getUrl } from 'src/utils/upload';
import { flatTree2Map, formatTreeData, setSpecifiedLevelTree } from 'src/utils/utils';
import { BIZ_CODE } from '../constants';

const formatData = (data = []) => {
  return (data || [])?.map(i => ({
    label: i.name || i.typeName,
    value: i.code || i.typeCode,
    ...i,
    children: i.children && i.children.length > 0 ? formatData(i.children) : null,
  }));
};

export default {
  namespace: 'address',
  state: {
    maxLevel: 3,
    specifiedLevelTree: [], // 当前区划树
    specifiedThreeLevelTree: [], // 3级树
    specifiedThreeLevelMap: [], // 3级树Map
    usualStations: ['v330100000000'], // 常住地
  },

  effects: {
    *fetchSpecifiedLevelTree({ payload }, { call, put }) {
      // 获取4级区划树
      const { fileId, lastModifyTime } = yield call(zlbApiExpenseAddressFileGet);
      // 对比更新
      const oldTime = localStorage.getItem('lastModifyTime');
      let addressData = [];
      let formatTreeAddress = [];
      let specifiedThreeLevelMap = [];
      try {
        const currentAddressList = yield call(() => getIDB('addressList'));
        if (
          oldTime !== String(lastModifyTime) ||
          !currentAddressList ||
          typeof currentAddressList === 'string'
        ) {
          // 需要更新
          const { result: fileUrl } = yield call(() =>
            getUrl({
              fileId,
              bizCode: BIZ_CODE,
            }),
          );
          const address = yield call(() => getFromFileUrl(fileUrl));
          const addressParse = JSON.parse(address || '[]');
          yield call(() => setIDB('addressList', addressParse));
          const threeAddressList = cloneDeep(addressParse);
          setSpecifiedLevelTree(threeAddressList, 1, 3); // 设置3级树
          yield call(() => setIDB('threeAddressList', threeAddressList));
          addressData = formatData(addressParse);
          formatTreeAddress = threeAddressList;
          // 同步时间戳
          localStorage.setItem('lastModifyTime', lastModifyTime);
        } else {
          const val = yield call(() => getIDB('addressList'));
          const threeLevelTree = yield call(() => getIDB('threeAddressList'));
          addressData = formatData(val || []);
          formatTreeAddress = formatData(threeLevelTree || []);
        }
        specifiedThreeLevelMap = flatTree2Map(formatTreeData(formatTreeAddress));
      } catch (error) {
        console.log('err', error);
      }
      yield put({
        type: 'update',
        payload: {
          specifiedLevelTree: addressData || [],
          specifiedThreeLevelTree: formatTreeAddress || [],
          specifiedThreeLevelMap,
        },
      });
    },

    *fetchSpecifiedLevel({ payload }, { call, put }) {
      const maxLevel = yield call(zlbApiExpenseAddressLevelGet, { formType: payload.formType });
      const tree = yield call(() => getIDB('addressList'));
      const threeLevelTree = yield call(() => getIDB('threeAddressList'));
      // 地址树过渡类型处理
      const addressTree = typeof tree === 'string' ? JSON.parse(tree) : tree;
      const addressThreeTree =
        typeof threeLevelTree === 'string' ? JSON.parse(threeLevelTree) : threeLevelTree;
      let addressList = [];
      if (maxLevel < 4) {
        addressList = addressThreeTree || [];
      } else {
        addressList = formatData(addressTree || []);
      }
      yield put({
        type: 'update',
        payload: {
          maxLevel,
          specifiedLevelTree: addressList || [],
        },
      });
      return maxLevel;
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
